import React, { useContext, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import { useKeycloak } from '@react-keycloak/web'
import { People, Search, ClearOutlined } from '@material-ui/icons'

import listContext from '../../../../Common/context/context'
import searchContext from '../../../../PropertySearch/FiltersComponent/context/context'
import Chip from '../../../../Common/Chip'
import { removeSpecialCharacters, removeWhiteSpace, getUserSFId, getQueryStringValue, getPollingAlertDuration, getErrorAlertDuration } from '../../../../PropertySearch/Utility/Utility.js'
import { fetchUserSuggestion, addListWithUser, unShareListWithUser } from '../../../../PropertySearch/Services/propertySearchService'
import { pollMessageStatus } from '../../../Utility/GetMessageStatus/GetMessageStatus'
import { readyToUpdate, pendingResponse } from '../../../Utility/PropertyListUtility'

const SharePropertyList = props => {
    const { setdisableClose } = props
    const { keycloak } = useKeycloak()
    let { propertyList, fetchListDetails } = useContext(listContext)

    const [modalIsOpen, setIsOpen] = useState(false)
    const [deleteUser, setDeleteUser] = useState(null)
    const [confirmClicked, setConfirmClicked] = useState(false)
    const [inputVal, setInputVal] = useState('')
    const [showSuggestions, isShowSuggestions] = useState(false)
    const [userSuggestions, setUserSuggestions] = useState([])
    const [showSuggestionSpinner, setShowSuggestionSpinner] = useState(false)
    const [usersSelected, setUsersSelected] = useState([])
    const [selectedUserObjs, setSelectedUserObjs] = useState({})
    const [existingUsers, setExistingUsers] = useState([...propertyList.sharedWithUsers])

    const { setShowAlert, setalertProps, fetchSavedLists, openModalWindow } = useContext(searchContext)
    const [saveClicked, setSaveClicked] = useState(false)

    useEffect(() => {
        if (propertyList && propertyList.sharedWithUsers) {
            setExistingUsers([...propertyList.sharedWithUsers])
        }
    }, [propertyList])

    useEffect(() => {
        if (saveClicked) {
            handleShareList()
        }
    }, [saveClicked])

    useEffect(() => {
        if (inputVal.length == 0) {
            setUserSuggestions([])
        }
        if (inputVal.length >= 2) {
            inputChanged()
        }
    }, [inputVal])

    const handleSelection = async (id, name) => {
        let temp = [...usersSelected]
        let tempObj = { ...selectedUserObjs }
        if (usersSelected.includes(id)) {
            delete temp[id]
            temp = usersSelected.filter(propertyId => propertyId !== id)
        } else {
            tempObj[id] = name
            temp.push(id)
        }
        setSelectedUserObjs(tempObj)
        setUsersSelected(temp)
    }

    async function handleUnShare(user) {
        setIsOpen(true)
        setDeleteUser(user)
        // setConfirmationMessage(`Selected ${user.listSharedUserName} will be removed from the list ?`)        
    }

    async function confirmRemoveExistingUser() {
        setConfirmClicked(true)
        await removeUser(deleteUser)
        setIsOpen(false)
        setConfirmClicked(false)
    }


    const onDelete = async (message, type) => {
        setShowAlert(false)

        switch (type) {
            case 'success':
                fetchSavedLists()
                await fetchListDetails()
                setdisableClose(false)
                setalertProps({ message, type })
                setShowAlert(true)

                // setRefreshSavedSearch(!refreshSavedSearch)
                break;

            case 'error':
                setExistingUsers(existingUsers.map(t => {
                    t.deleting = false
                    return t
                }))
                setdisableClose(false)
                setalertProps({ message, type, duration: getErrorAlertDuration() })
                setShowAlert(true)
                break;

            default: // type is warning
                setalertProps({ message, type, duration: getPollingAlertDuration() })
                setShowAlert(true)
                break;
        }
    }


    const isUserBeingRemoved = () => {
        return existingUsers.filter(x => x.deleting).length ? true : false
    }

    async function removeUser(user) {
        setExistingUsers(existingUsers.map(t => {
            if (t.listSharedUser === user.listSharedUser) {
                t.deleting = true
            }
            return t
        }))
        let id = user.listSharedUser
        const omniViewUserId = getQueryStringValue('userId')
        const list_id = propertyList.polarisPropertySearchCriteriaId// getQueryStringValue('list_id')
        const list_ov_id = propertyList.omniViewPropertyListId// getQueryStringValue('list_ov_id')
        let payload = {
            "userId": keycloak.subject,
            // omniViewUserId,
            "listSharedUser": id,
            "polarisPropertySearchCriteriaId": list_id,
            "omniViewPropertyListId": list_ov_id,
            "omniViewSharedPropertyListId": user.omniViewSharedPropertyListId,
            // 'lastModifiedById': getUserSFId(),
            // "polarisLastModifiedById": keycloak.subject,
            // "polarisLastModifiedByUserName": keycloak.tokenParsed.name
        }
        setdisableClose(true)
        let response
        if (await readyToUpdate()) {
            response = await unShareListWithUser(payload)
        } else {
            setdisableClose(false)
            response = await pendingResponse()
        }

        if (response && response.status === 200) {
            pollMessageStatus(response.data.messageId, onDelete, '', 'List unshared from user !!', 'Something went wrong !!')
        } else {
            setdisableClose(false)
            const errorMessage = response.data && response.data.message ? response.data.message : 'Something went wrong !!'
            setalertProps({ message: errorMessage, type: 'error' })
            setShowAlert(true)
        }

    }
    // after share open the popup quickly... its taking time to reflect

    const handleChange = e => {
        let { value } = e.target
        setInputVal(value)
    }

    function inputChanged() {
        let suggestionCriteria = {}
        let payLoad = ''
        let newInputValue = inputVal
        newInputValue = removeSpecialCharacters(newInputValue)
        newInputValue = removeWhiteSpace(newInputValue)
        if (newInputValue.length >= 2) {
            setShowSuggestionSpinner(true)
            suggestionCriteria = {
                name: newInputValue,
            }
            payLoad = JSON.stringify({
                suggestion: suggestionCriteria
            })
            fetchSuggestion(payLoad)
        }
    }

    async function fetchSuggestion(payLoad) {
        const response = await fetchUserSuggestion(payLoad)
        if (response && response.status === 200) {
            if (response.data && response.data.data) {
                const omniViewUserId = propertyList.omniViewUserId
                let tempSugesstions = response.data.data
                let existingUserIds = existingUsers.map(obj => obj.listSharedUser)
                tempSugesstions = tempSugesstions.filter(user => !(existingUserIds.includes(user.omniViewUserId)) && user.omniViewUserId !== omniViewUserId)
                setUserSuggestions(tempSugesstions)
                setShowSuggestionSpinner(false)
                isShowSuggestions(true)
            }
        }
    }

    const getPayload = () => {
        // const user_SFId = getUserSFId();
        // const omniViewUserId = getQueryStringValue('userId')
        const list_id = propertyList.polarisPropertySearchCriteriaId //getQueryStringValue('list_id')
        let payload = {
            "userId": keycloak.subject,
            // omniViewUserId,
            "listSharedUsers": usersSelected,
            "polarisPropertySearchCriteriaId": list_id,
            "omniViewPropertyListId": propertyList.omniViewPropertyListId ? propertyList.omniViewPropertyListId : '',
            // 'lastModifiedById': getUserSFId(),
            // "polarisLastModifiedById": keycloak.subject,
            // "polarisUserName": keycloak.tokenParsed.name
        }
        return payload
    }

    const onUpdate = async (message, type) => {

        try {

            if (type === 'success') {
                fetchSavedLists()
                await fetchListDetails()
            }
            setalertProps({ message, type, duration: type === 'error' ? getErrorAlertDuration() : '' })
            setShowAlert(true)

            openModalWindow(false)

        } catch (error) {
            console.log(' error in on-Update :: ', error)
        }

    }

    const handleShareList = async () => {
        try {
            setdisableClose(false)
            let response
            if (await readyToUpdate()) {
                const payload = getPayload()
                openModalWindow(true)
                props.closeModal()
                response = await addListWithUser(payload)

            } else {
                response = await pendingResponse()
            }

            setSaveClicked(false)

            if (response && response.status === 200) {
                pollMessageStatus(response.data.messageId, onUpdate, '', 'List shared with users !!', 'Something went wrong !!')
            } else {
                const errorMessage = response.data && response.data.message ? response.data.message : 'Something went wrong !!'
                setalertProps({ message: errorMessage, type: 'error' })
                setShowAlert(true)
            }

        }
        catch (e) {
            console.log('Error handle-ShareList:: ', e)
            props.closeModal()
        }
    }

    const onChipDelete = (id) => {
        let temp = { ...selectedUserObjs }
        delete temp[id]
        setSelectedUserObjs(temp)
        setUsersSelected(usersSelected.filter(e => e !== id))
    }

    function closeModal() {
        setIsOpen(false)
    }

    // function closeMainModal() {
    //     if (!confirmClicked) {
    //         props.closeModal()
    //     }
    // }

    const customStyles = {
        content: {
            top: '30%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -40%)',
            padding: '10px'
        },
        overlay: { zIndex: 1050 }
    }

    return (
        <div data-testid="test-div-container-share-list" className='flex flex-col gap-2 shareList-box'>
            <div className='flex flex-row justify-between border-b-1 border-base p-4'>
                <div className="flex">
                    <span className='pr-4'>
                        <People fontSize="small" />
                    </span>
                    <span className='px-2'>
                        Share Property list
                    </span>
                </div>
                <div>
                    <a data-testid="test-share-list-close" className={`${confirmClicked || isUserBeingRemoved() ? ' c-disabled pointer-events-none' : ''}`}
                        onClick={props.closeModal}>
                        <ClearOutlined />
                    </a>
                </div>
            </div>
            <div className="py-2 px-4 popover-w disable-scrollbars flex">
                <div className="bg-gray-5 p-3 flex rounded">
                    {showSuggestionSpinner ? <span className="loader h-6 w-6 items-center justify-center text-center absolute" ></span> : <Search className="absolute" />}
                    <input
                        data-testid="test-input-Search-user"
                        value={inputVal}
                        style={{ width: 400 }}
                        onFocus={() => isShowSuggestions(true)}
                        onChange={handleChange}
                        className="shadow appearance-none pl-7 pr-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline rounded bg-gray-5"
                        type="text"
                        placeholder="Search for users">
                    </input>
                </div>
            </div>
            <div className="px-8 overflow-y-auto popover-w disable-scrollbars">
                {showSuggestions && <div onMouseLeave={() => isShowSuggestions(false)} className={`absolute bg-white shadow-5 overflow-y-auto ${userSuggestions.length > 0 ? 'h-screen-25 w-1/2' : ''}`}>
                    {userSuggestions.length > 0 ? userSuggestions.map((user, index) => (
                        <div data-testid={`test-user-option-${index}`}
                            onClick={() => handleSelection(user.omniViewUserId, user.name)}
                            role="menuitem"
                            key={user.omniViewUserId}
                            className="flex flex-row border-b-1 border-base px-4 py-3 cursor-pointer hover:bg-gray-15">
                            <div className={usersSelected.includes(user.omniViewUserId) ? 'ml-2 pr-2 absolute' : 'hide ml-2 pr-2 absolute'}>&#10004;</div>
                            <div className="pl-6">
                                <div className="text-2">{user.name}</div>
                            </div>
                        </div>))
                        :
                        ""
                    }
                </div>}
            </div>
            <div className='flex flex-col h-full'>
                <div className="p-4 flex flex-col overflow-y-auto selectedlist">
                    {usersSelected.length ? <div className="flex flex-col">
                        <div className="px-3 text-2 font-semibold">Current Selected users: </div>
                        <div>
                            {usersSelected.map((t, i) => <Chip key={t} onChipDelete={onChipDelete} name={selectedUserObjs[t]} id={t} />)}
                        </div>
                    </div> : ''}
                    {propertyList.sharedWithUsers.length ? <div className="flex flex-col">
                        <div className="px-3 text-2 font-semibold">Existing users: </div>
                        <div>
                            {existingUsers.map((user, index) => (
                                <span key={index} className='capitalize badge rounded-pill px-5 mr-3 mb-4 py-3 text-primary bg-gray-10'>
                                    {user.listSharedUserName}
                                    {user.deleting ?
                                        <span className="-mr-3">
                                            <button className="btn bg-transparent p-0 c-disabled">
                                                <span className="customloader h-5 w-5 mx-2" ></span>
                                            </button>
                                        </span>
                                        :
                                        <span className="-mr-3">
                                            <button data-testid={`test-existing-user-${index}`} type="button cursor-pointer" onClick={() => handleUnShare(user)}>
                                                <i className="fa fa-close"></i>
                                            </button>
                                        </span>}
                                </span>
                            ))}
                        </div>
                    </div> : ''}
                </div>
                <div className='p-4 flex justify-end space-x-4 mt-auto border-t-1 border-base'>
                    <div>
                        <button data-testid='test-share-list-close-button' onClick={props.closeModal} className='btn btn-sm' type='button'>
                            Close
                        </button>
                    </div>

                    {saveClicked ?
                        <button data-testid='test-button-sharing' className="btn btn-sm btn-primary c-disabled">
                            <span className="loader h-5 w-5 mx-2" ></span>
                            <span className="px-2">Sharing...</span>
                        </button>
                        :
                        <button data-testid='test-button-share' onClick={() => { setSaveClicked(true) }} className={`btn btn-sm btn-primary rouded ${usersSelected.length === 0 ? 'c-disabled' : ''}`}>Share list</button>
                    }
                </div>
            </div>
            <Modal ariaHideApp={false} isOpen={modalIsOpen} onRequestClose={closeModal}
                closeTimeoutMS={500} style={customStyles} >
                <div data-testid="test-delete-select-property-popup" className='flex flex-col py-4 gap-4 drawer-w'>
                    <div className='flex flex-row border-b-1 border-base pb-2'>
                        <span className='p-3'>
                            {deleteUser && <span className='text-3'>List will be unshared from {<b>{deleteUser.listSharedUserName}</b>}?</span>}
                        </span>
                    </div>
                    <div className='py-2 px-4'>
                        <div className='flex justify-end space-x-4 mt-auto'>
                            <div>
                                <button data-testid='test-delete-property-cancel' onClick={closeModal} className='btn btn-sm' type='button'>Close</button>
                            </div>
                            <div>
                                {confirmClicked ?
                                    <button className="btn btn-sm btn-primary c-disabled">
                                        <span className="loader h-5 w-5 mx-2" ></span>
                                        <span className="px-2">Confirm</span>
                                    </button>
                                    :
                                    <button data-testid='test-delete-user-confirm' onClick={() => confirmRemoveExistingUser()} className={`btn btn-sm btn-primary`}>Confirm</button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default SharePropertyList

SharePropertyList.propTypes = {
    setdisableClose: PropTypes.func,
}